import {Component, Input, OnInit} from '@angular/core';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {UserService} from '../../../../../services/user-services/user.service';
import {NeedHelpComponent} from '../../../../../shared/components/ux/need-help/need-help.component';
import {AccommodationPaymentDetailsComponent} from '../accommodation-payment-details/accommodation-payment-details.component';
import {IconComponent} from '../../../../../shared/components/icons-svgs/icons-svgs.component';
import {DatePipe, NgClass, NgIf} from '@angular/common';
import {ItemBadgesComponent} from '../../../../../shared/components/item-badges/item-badges.component';
import {Agent} from '../../../../../models/agent';

@Component({
    selector: 'app-component-booking-info',
    templateUrl: './component-booking-info.component.html',
    styleUrls: ['./component-booking-info.component.scss'],
    standalone: true,
  imports: [NgIf, IconComponent, NgClass, AccommodationPaymentDetailsComponent, NeedHelpComponent, TranslateModule, DatePipe, ItemBadgesComponent]
})
export class ComponentBookingInfoComponent implements OnInit {

  @Input() public booking: any;
  @Input() public room: any;
  @Input() public page: string;

  public isMobile: boolean = false;
  public locale: string;
  public isDisplay: boolean = false;
  public agent: Agent;

  constructor(
    private _translateService: TranslateService,
    private userService: UserService,
  ) {
  }

  ngOnInit(): void {
    this.locale = this._translateService.currentLang;
    this.isMobile = this.userService.isMobileUser;
    this.agent = this.userService.userInformations.agent;
  }

  public displayInfos(): void {
    this.isDisplay = !this.isDisplay;
  }
}
